/**
 * Normalisation for search text stored in first-party analytics. Shared by the
 * client (before sending) and the ingest route (before storing), because the
 * route cannot trust what the client sent.
 */
export const SEARCH_QUERY_MAX_CHARS = 60

const EMAIL_RE = /[^\s@]+@[^\s@]+\.[^\s@]+/g
const PHONE_RE = /\+\d[\d\s().-]{7,}\d|\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g
const DIGIT_RUN_RE = /\d{5,}/g
// Numbers of two or more characters joined by spaces, dots or dashes: card
// numbers (4111 1111 1111 1111) and SSN-style values (123-45-6789). A lone
// single-character number breaks the run, so "model 3 2024 2025" stays intact.
const JOINED_NUMBERS_RE = /\b\d{2,}(?:[\s.-]+\d{2,})+\b/g
const MIN_JOINED_NUMBER_LENGTH = 9

/** Lowercases, replaces personal-looking tokens, and caps the length. */
export function normalizeSearchQuery(query: string): string {
  return query
    .replace(EMAIL_RE, '[email]')
    .replace(JOINED_NUMBERS_RE, (run) =>
      run.replace(/\D/g, '').length >= MIN_JOINED_NUMBER_LENGTH ? '[number]' : run,
    )
    .replace(PHONE_RE, '[number]')
    .replace(DIGIT_RUN_RE, '[number]')
    .trim()
    .toLowerCase()
    .slice(0, SEARCH_QUERY_MAX_CHARS)
    .trimEnd()
}
